import { setSessionExpired } from './Slices/UserSlice';

export const setupInterceptor = (store) => {
    const { fetch: originalFetch } = window;

    window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        // Clone the response to read the body without consuming it
        const clonedResponse = response.clone();

        try {
            if (response.status === 401) {
                store.dispatch(setSessionExpired(true));
            } else {
                const data = await clonedResponse.json();
                // Check for specific backend error patterns for expired token
                if (
                    (data.status === 'failed' || data.status === false) &&
                    (data.message === 'Token has expired' ||
                        data.description === 'Token has expired' ||
                        data.message === 'Internal Server Error' && data.error === 'Token has expired')
                ) {
                    store.dispatch(setSessionExpired(true));
                }
            }
        } catch (e) {
            // If response is not JSON or other error, just ignore
        }

        return response;
    };
};
